import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CustomImageSlider } from '@/components/hotel/ CustomImageSlider';
import Picture1 from '@/image/hotel/hotel_1.jpg';
import Picture2 from '@/image/hotel/hotel_2.jpg';
import Picture3 from '@/image/hotel/hotel_3.jpg';
import ThreeImages from '../common/ThreeImages';

export const ApartmentContent = () => {
  // ① URLの先頭セグメントを取得し、"/en/" なら英語、それ以外は日本語として扱う
  const location = useLocation();
  const langSegment = location.pathname.split('/')[1];
  const useEnglish = langSegment === 'en';

  // 画像スライダーに使用する画像データ
  const images = [
    {
      src: Picture1,
      title: 'Original and Hand Selected Furniture',
      place: 'daikanyama 01',
      text: 'Original and Hand Selected Furniture',
      sizeClass: 'w-[460px] h-[679px]',
    },
    {
      src: Picture2,
      title: 'Kitchen & Coffee Amenities',

      place: 'daikanyama 01',
      text: 'Kitchen & Coffee Amenities',
      sizeClass: 'w-[253px] h-[264px]',
    },
    {
      src: Picture3,
      title: 'Long and Short Stay',
      place: 'daikanyama 01',
      text: 'Long and Short Stay',
      sizeClass: 'w-[400px] h-[477px]',
    },
  ];

  return (
    <div>
      {/* -- 上部テキスト部分 -- */}
      <div className="md:flex md:justify-center">
        <div className="max-md:pt-14 md:pt-36 mb-[100px] md:max-w-xl">
          {/* ( THE APARTMENT HOTEL ) の切り替え */}
          <div className="text-center mb-4 text-lg">
            ( THE APARTMENT HOTEL )
          </div>

          {/* 上部の文章部分を言語切り替え */}
          {useEnglish ? (
            <div className="text-base">
              <p className="mb-3">
                When visiting a place, the best way to experience it is to stay
                for an extended period of time.
              </p>
              <p className="mb-3">
                A new style of “between traveling and living,” offers reasonable
                monthly plans that can be used as little as one month.
              </p>
              <p className="mb-3">
                A variety of options, such as a place to stay on a long-term
                business trip, a second living space, or a study space
                concentrate on their work.
              </p>
            </div>
          ) : (
            <div className="text-base">
              <p className="mb-3">
                ある場所を訪れる時、その土地のネイバーフッドとしての体験を得る
                最善の方法は、長期間の滞在をしてみること。
              </p>
              <p className="mb-3">
                「旅と住むの間」という新しいスタイルを提案するザ・アパートメントホテルは、
                一ヶ月から利用できるリーズナブルなマンスリープランを提案しています。
              </p>
              <p className="mb-3">
                長期出張の滞在先や第二の生活拠点、またテレワークで仕事に集中するための
                書斎代わり等、様々なシーンに。
              </p>
            </div>
          )}
        </div>
      </div>

      {/* -- ROOM -- */}
      <div className="md:px-[300px] text-center md:mb-[50px] text-lg">
        (ROOM)
      </div>

      {/* SP時のみ表示: CustomImageSlider */}
      <div className="md:hidden max-md:my-6">
        <CustomImageSlider
          startIndex={0}
          images={images}
          className="w-[251px] h-[355px]"
        />
        <div className="pt-10 flex justify-end">
          <CustomImageSlider
            startIndex={1}
            images={images}
            className="w-[160px] h-[160px]"
          />
        </div>
        <div className="pt-10 flex justify-end">
          <CustomImageSlider
            startIndex={2}
            images={images}
            className="w-[277px] h-[320px]"
          />
        </div>
      </div>

      {/* PCのみ表示: ThreeImages */}
      <div className="hidden md:block">
        <ThreeImages images={images} />
      </div>

      {/* -- フッターのテキスト部分 -- */}
      <div className="md:flex md:justify-center">
        <div className="pt-8 mb-[150px] md:max-w-xl text-[15px]">
          {useEnglish ? (
            <>
              <div className="mb-3">
                A cozy sofa and a large table for working or eating. The sun is
                shining, and with music playing comfortably through the speakers
                and a cup of coffee or a glass of wine, you can have a great
                time without needing anything else.
              </div>
              <div className="mb-3">
                Not a famous brand, but a favorite piece of furniture that you
                will want to keep for a long time and that you will love. The
                interior design is not about sophistication, but rather about a
                simple, temperature-controlled atmosphere. In such a relaxed
                space without being over-designed, you will find not expensive
                but thoughtful furniture, interior decorations, cups, and
                dishes.
              </div>
              <div>
                {/* Art books, records,  */}
                books, and artists’ works are scattered here and there, giving
                the space the reality of living in the city of Tokyo.
              </div>
            </>
          ) : (
            <>
              <div className="mb-3">
                居心地のいいソファと、大きなテーブル。スピーカーから流れる心地よい音楽と、コーヒーやワインの香りで、何も足りないものがない満ち足りた時間を過ごすことができます。
              </div>
              <div className="mb-3">
                有名ブランドではないけれど、長く愛用したくなるお気に入りの家具。過度にデザインされすぎない、シンプルでありながら温度を感じる空間。そんなリラックスできる部屋には、高価ではないけれど考え抜かれた家具やインテリア、カップや食器が並んでいます。
              </div>
              {/* TODO:一時コメントアウト */}
              <div>
                {/* アートブックやレコード、 */}
                本、アーティストの作品が点在し、東京で暮らすリアルな日常を味わえる空間になっています。
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
